export const isValidEmail = email => !!email && /\S+@\S+\.\S+/.test(email);
export const isProcessorSupportedCurrency = currencyOption => currencyOption.isProcessorSupportedCurrency;
export const hasValidCurrencyInPortal = currencies => !!currencies.filter(isProcessorSupportedCurrency).length;